<app-dropdown
  icon="address-card"
  [items]="this.subscriptionItems"
  (selectedChange)="this.changed($event)"
  [selected]="this.selectedSubscription"
  ariaLabel="Kies abonnement"
/>
